// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import 'core-js/es'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './App.less'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { BrowserRouter } from 'react-router-dom'
import './backend/FetchFilter'

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replace) {
    return this.split(search).join(replace)
  }
}

const container = document.getElementById('root')

const app = createRoot(container)

app.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()

// init webfunny monitor
const isPro = window.location.href.includes('casdoor.angelalign.com')
const setMonitorHead = () => {
  if (process.env.NODE_ENV !== 'production') return
  // 动态创建 script 标签
  const env = isPro ? 'pro' : 'sit'
  const script = document.createElement('script')
  script.src = isPro ? '/webfunny/monitor-pro.js' : '/webfunny/monitor-sit.js'
  script.async = true // 异步加载
  script.onload = () => {
    const userInfo = window.localStorage.wmUserInfo
      ? JSON.parse(window.localStorage.wmUserInfo)
      : {}
    window.localStorage.wmUserInfo = JSON.stringify({
      ...userInfo,
      projectVersion: '1.0.0',
      env: env
    })
  }
  script.onerror = () => {
    console.error('Error loading Monitor script')
  }

  // 将 script 标签添加到 head 或 body 中
  document.head.appendChild(script)
}
setMonitorHead()
